import { render, staticRenderFns } from "./PageArticle.vue?vue&type=template&id=63485fce&"
import script from "./PageArticle.vue?vue&type=script&lang=js&"
export * from "./PageArticle.vue?vue&type=script&lang=js&"
import style0 from "./PageArticle.vue?vue&type=style&index=0&id=63485fce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RichTextRenderReplacer: require('/opt/build/repo/components/common/RichTextRenderReplacer.vue').default})
